import { render, staticRenderFns } from "./PurchaseTime.vue?vue&type=template&id=28cd2fcc&scoped=true&"
import script from "./PurchaseTime.vue?vue&type=script&lang=ts&"
export * from "./PurchaseTime.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseTime.vue?vue&type=style&index=0&id=28cd2fcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd2fcc",
  null
  
)

export default component.exports